import { Switch } from 'react-router-dom';
import { getAllRouteComponents } from '../library/Routes';
import AuthProvider from 'services/Auth/AuthProvider';

function PageRoutes() {
  return (
    <AuthProvider>
        <Switch>{getAllRouteComponents()}</Switch>
    </AuthProvider>
  )
}

export default PageRoutes;
